"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssToJs = exports.minifyCss = void 0;

var _postcss = _interopRequireDefault(require("postcss"));

var _camelCase = _interopRequireDefault(require("lodash/camelCase"));

var _upperFirst = _interopRequireDefault(require("lodash/upperFirst"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _ = {
  camelCase: _camelCase.default,
  upperFirst: _upperFirst.default
};

var minifyCss = function minifyCss(cssString) {
  return cssString.replace(/\r?\n|\r/g, '') // Remove line breaks
  .replace(/(\|\\r|\	|\\f|\\v)+/g, '') // Remove tabs etc.
  .replace(/\/\*[\s\S]*?\*\/|([^\\:]|^)\/\/.*$/gm, '$1') // Remove comments.
  .replace(/ +/g, ' ') // Remove redundant whitespace.
  .replace(/ *(:|;|{|}) */g, '$1');
}; // Remove spaces around those characters


exports.minifyCss = minifyCss;

var cssToJs = function cssToJs(cssString) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$cssToString = _ref.cssToString,
      cssToString = _ref$cssToString === void 0 ? false : _ref$cssToString;

  var root = _postcss.default.parse(cssString, {});

  var rootRules = !!root && !!root.nodes && root.nodes.filter(function (node) {
    return node.type === 'rule';
  });

  if (!rootRules || rootRules.length < 1) {
    if (console) console.error('No CSS selectors found');
    return undefined;
  }

  return Object.entries(rootRules).reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        _ref3$ = _ref3[1],
        selector = _ref3$.selector,
        nodes = _ref3$.nodes;

    var formatToObject = function formatToObject(prop) {
      var camelProp = _.camelCase(prop);

      return prop.startsWith('-') ? _.upperFirst(camelProp) : camelProp;
    };

    var selectors = !!selector ? selector.split(',').map(function (s) {
      return s.trim();
    }) : [];
    var cssDeclarations = !!nodes ? nodes.filter(function (node) {
      return node.type === 'decl';
    }) : [];
    var cssDeclarationsFormatted = !!cssToString ? cssDeclarations.map(function (_ref4) {
      var prop = _ref4.prop,
          value = _ref4.value;
      return "".concat(prop, ": ").concat(value, ";");
    }).join(' ') : cssDeclarations.reduce(function (accDecl, _ref5) {
      var prop = _ref5.prop,
          value = _ref5.value;
      return _objectSpread({}, accDecl, _defineProperty({}, formatToObject(prop), value));
    }, {});
    var valuePairs = selectors.length > 1 ? selectors.reduce(function (selectorsAcc, selectorsKey) {
      return _objectSpread({}, selectorsAcc, _defineProperty({}, selectorsKey, cssDeclarationsFormatted));
    }, {}) : _defineProperty({}, selector, cssDeclarationsFormatted);
    var mergedValuePairs = Object.entries(valuePairs).reduce(function (mergedPairs, _ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          key = _ref8[0],
          value = _ref8[1];

      var mergeValue = function mergeValue(valueKey) {
        return !!cssToString ? "".concat(acc[valueKey]).concat(value) : _objectSpread({}, acc[valueKey], value);
      };

      var mergedValue = acc.hasOwnProperty(key) ? mergeValue(key) : value;
      return _objectSpread({}, mergedPairs, _defineProperty({}, key, mergedValue));
    }, {});
    return _objectSpread({}, acc, mergedValuePairs);
  }, {});
};

exports.cssToJs = cssToJs;
var _default = cssToJs;
exports.default = _default;